// extracted by mini-css-extract-plugin
var _1 = "PresencePopOver-module__animateUploadProgressBarWidth--tfA_A";
var _2 = "PresencePopOver-module__animatedBackground--NCDPW";
var _3 = "PresencePopOver-module__container--JwgRj";
var _4 = "PresencePopOver-module__name--yZgyh";
var _5 = "PresencePopOver-module__separator--C7kwN";
var _6 = "PresencePopOver-module__subtitle--F5PW6";
var _7 = "PresencePopOver-module__title--e_A_u";
var _8 = "PresencePopOver-module__userRow--jgMbx";
var _9 = "PresencePopOver-module__userText--uukB7";
export { _1 as "animateUploadProgressBarWidth", _2 as "animatedBackground", _3 as "container", _4 as "name", _5 as "separator", _6 as "subtitle", _7 as "title", _8 as "userRow", _9 as "userText" }
